(function () {
  'use strict';

  function $(root, selector) {
    return root.querySelector(selector);
  }

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function formatSchedules(schedules) {
    if (!schedules) return '';
    return escapeHtml(schedules).replace(/\r\n|\r|\n/g, '<br>');
  }

  function getStorePhone(store) {
    return store.phone || store.cell || '';
  }

  function getMapsHref(store) {
    if (store.maps_url) return store.maps_url;
    return (
      'https://www.google.com/maps/search/?api=1&query=' +
      encodeURIComponent(String(store.lat) + ',' + String(store.lng))
    );
  }

  function fetchJson(url) {
    return fetch(url, { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error('No se pudo cargar JSON: ' + r.status);
      return r.json();
    });
  }

  function loadGoogleMaps(apiKey) {
    return new Promise(function (resolve, reject) {
      if (window.google && window.google.maps) return resolve();
      if (!apiKey) return reject(new Error('Falta Google Maps API Key'));

      var existing = document.querySelector('script[data-store-locator-google="1"]');
      if (existing) {
        existing.addEventListener('load', function () {
          resolve();
        });
        existing.addEventListener('error', function () {
          reject(new Error('No se pudo cargar Google Maps'));
        });
        return;
      }

      var script = document.createElement('script');
      script.async = true;
      script.defer = true;
      script.dataset.storeLocatorGoogle = '1';
      script.src = 'https://maps.googleapis.com/maps/api/js?libraries=places&key=' + encodeURIComponent(apiKey);
      script.onload = function () {
        resolve();
      };
      script.onerror = function () {
        reject(new Error('No se pudo cargar Google Maps'));
      };
      document.head.appendChild(script);
    });
  }

  function normalizeStoresToArray(storesInfo, countryName, cityName) {
    var out = [];
    if (!storesInfo) return out;

    function pushStore(storeKey, store) {
      if (!store) return;
      var lat = Number(store.lat);
      var lng = Number(store.lng);
      if (!Number.isFinite(lat) || !Number.isFinite(lng)) return;
      out.push({
        key: String(storeKey || store.name || 'Tienda'),
        name: String(store.name || storeKey || 'Tienda'),
        address: store.address || '',
        phone: store.phone || '',
        cell: store.cell || '',
        whatsapp: store.whatsapp || '',
        email: store.email || '',
        schedules: store.schedules || '',
        website: store.website || '',
        maps_url: store.maps_url || '',
        lat: lat,
        lng: lng
      });
    }

    if (countryName && storesInfo[countryName] && storesInfo[countryName].cities) {
      var country = storesInfo[countryName];
      if (cityName && country.cities[cityName] && country.cities[cityName].stores) {
        var stores = country.cities[cityName].stores;
        Object.keys(stores).forEach(function (k) {
          pushStore(k, stores[k]);
        });
        return out;
      }

      Object.keys(country.cities).forEach(function (cityK) {
        var city = country.cities[cityK];
        if (!city || !city.stores) return;
        Object.keys(city.stores).forEach(function (k) {
          pushStore(k, city.stores[k]);
        });
      });
      return out;
    }

    Object.keys(storesInfo).forEach(function (countryK) {
      var c = storesInfo[countryK];
      if (!c || !c.cities) return;
      Object.keys(c.cities).forEach(function (cityK) {
        var city = c.cities[cityK];
        if (!city || !city.stores) return;
        Object.keys(city.stores).forEach(function (k) {
          pushStore(k, city.stores[k]);
        });
      });
    });
    return out;
  }

  function StoreLocator(root) {
    this.root = root;
    this.controlsEl = $(root, '.store-locator__controls');
    this.resultsEl = $(root, '.store-locator__results');
    this.mapEl = $(root, '.store-locator__map');

    this.storesUrl = root.dataset.storesUrl;
    this.apiKey = root.dataset.googleApiKey || '';
    this.defaultCountry = root.dataset.defaultCountry || '';
    this.defaultLat = Number(root.dataset.defaultLat);
    this.defaultLng = Number(root.dataset.defaultLng);
    this.enableGeolocation = root.dataset.enableGeolocation === 'true';

    this.storesInfo = null;
    this.map = null;
    this.infoWindow = null;
    this.markers = [];

    this.countrySelect = null;
    this.citySelect = null;
    this.activeIndex = -1;
  }

  StoreLocator.prototype.init = function () {
    var self = this;
    return Promise.all([fetchJson(this.storesUrl), loadGoogleMaps(this.apiKey)])
      .then(function (res) {
        self.storesInfo = res[0];
        self.renderControls();
        self.initMap();
        self.tryGeolocation();
        self.syncFromDefaults();
      })
      .catch(function (e) {
        self.resultsEl.innerHTML =
          '<p style="margin:0">No fue posible inicializar el localizador. ' +
          escapeHtml(e && e.message ? e.message : 'Error desconocido') +
          '</p>';
      });
  };

  StoreLocator.prototype.renderControls = function () {
    var self = this;

    var countrySelect = document.createElement('select');
    countrySelect.className = 'store-locator__select store-locator__select--country input-full';
    countrySelect.setAttribute('aria-label', 'Seleccionar país');

    var citySelect = document.createElement('select');
    citySelect.className = 'store-locator__select store-locator__select--city input-full';
    citySelect.setAttribute('aria-label', 'Seleccionar ciudad');

    this.controlsEl.innerHTML = '';
    this.controlsEl.appendChild(countrySelect);
    this.controlsEl.appendChild(citySelect);

    this.countrySelect = countrySelect;
    this.citySelect = citySelect;

    this.populateCountries();
    this.populateCities('');

    countrySelect.addEventListener('change', function () {
      var country = self.getSelectedCountry();
      self.populateCities(country);
      self.paint();
    });

    citySelect.addEventListener('change', function () {
      self.paint();
    });
  };

  StoreLocator.prototype.populateCountries = function () {
    var select = this.countrySelect;
    var countries = Object.keys(this.storesInfo || {});
    countries.sort(function (a, b) {
      return a.localeCompare(b);
    });

    select.innerHTML = '<option value="">Seleccionar país</option>';
    countries.forEach(function (name) {
      var opt = document.createElement('option');
      opt.value = name;
      opt.textContent = name;
      select.appendChild(opt);
    });
  };

  StoreLocator.prototype.populateCities = function (countryName) {
    var select = this.citySelect;
    select.innerHTML = '<option value="">Seleccionar ciudad</option>';

    if (!countryName || !this.storesInfo || !this.storesInfo[countryName] || !this.storesInfo[countryName].cities) {
      return;
    }

    var cities = Object.keys(this.storesInfo[countryName].cities);
    cities.sort(function (a, b) {
      return a.localeCompare(b);
    });

    cities.forEach(function (name) {
      var opt = document.createElement('option');
      opt.value = name;
      opt.textContent = name;
      select.appendChild(opt);
    });
  };

  StoreLocator.prototype.initMap = function () {
    var center = { lat: this.defaultLat || 0, lng: this.defaultLng || 0 };
    this.map = new google.maps.Map(this.mapEl, {
      center: center,
      zoom: 6,
      mapTypeControl: false,
      streetViewControl: false,
      fullscreenControl: true
    });
    this.infoWindow = new google.maps.InfoWindow();
  };

  StoreLocator.prototype.tryGeolocation = function () {
    var self = this;
    if (!this.enableGeolocation) return;
    if (!navigator.geolocation) return;

    navigator.geolocation.getCurrentPosition(
      function (pos) {
        if (!self.map) return;
        var lat = Number(pos.coords.latitude);
        var lng = Number(pos.coords.longitude);
        if (!Number.isFinite(lat) || !Number.isFinite(lng)) return;
        self.map.setCenter({ lat: lat, lng: lng });
        self.map.setZoom(11);
      },
      function () {
        // Silencioso: si falla, seguimos con defaults.
      },
      { enableHighAccuracy: false, timeout: 6000, maximumAge: 600000 }
    );
  };

  StoreLocator.prototype.syncFromDefaults = function () {
    if (this.defaultCountry) {
      this.countrySelect.value = this.defaultCountry;
      this.populateCities(this.defaultCountry);
    }
    this.paint();
  };

  StoreLocator.prototype.getSelectedCountry = function () {
    return this.countrySelect ? this.countrySelect.value : '';
  };

  StoreLocator.prototype.getSelectedCity = function () {
    return this.citySelect ? this.citySelect.value : '';
  };

  StoreLocator.prototype.clearMarkers = function () {
    this.markers.forEach(function (m) {
      m.setMap(null);
    });
    this.markers = [];
    this.activeIndex = -1;
  };

  StoreLocator.prototype.paint = function () {
    if (!this.map || !this.storesInfo) return;

    var country = this.getSelectedCountry();
    var city = this.getSelectedCity();

    var stores = normalizeStoresToArray(this.storesInfo, country, city);
    this.clearMarkers();
    this.renderList(stores);

    var bounds = new google.maps.LatLngBounds();
    var self = this;

    stores.forEach(function (s, idx) {
      var marker = new google.maps.Marker({
        position: { lat: s.lat, lng: s.lng },
        map: self.map,
        title: s.name
      });

      marker.addListener('click', function () {
        self.activateStore(idx, stores, marker);
      });

      self.markers.push(marker);
      bounds.extend(marker.getPosition());
    });

    if (stores.length) {
      self.map.fitBounds(bounds, 60);
    } else if (country && self.storesInfo[country] && Number.isFinite(self.storesInfo[country].lat)) {
      self.map.setCenter({ lat: Number(self.storesInfo[country].lat), lng: Number(self.storesInfo[country].lng) });
      self.map.setZoom(6);
    } else if (Number.isFinite(self.defaultLat) && Number.isFinite(self.defaultLng)) {
      self.map.setCenter({ lat: self.defaultLat, lng: self.defaultLng });
      self.map.setZoom(6);
    }
  };

  StoreLocator.prototype.buildStoreDetailsHtml = function (store, includeMapsLink) {
    var phone = getStorePhone(store);
    var html =
      (store.address ? '<div>' + escapeHtml(store.address) + '</div>' : '') +
      (phone ? '<div>' + escapeHtml(phone) + '</div>' : '') +
      (store.schedules ? '<div>' + formatSchedules(store.schedules) + '</div>' : '');

    if (includeMapsLink) {
      html +=
        '<div style="margin-top:8px"><a href="' +
        escapeHtml(getMapsHref(store)) +
        '" target="_blank" rel="noopener">Ver en Google Maps</a></div>';
    }

    return html;
  };

  StoreLocator.prototype.activateStore = function (idx, stores, marker) {
    this.activeIndex = idx;

    var s = stores[idx];
    var html =
      '<div style="max-width:260px">' +
      '<strong>' +
      escapeHtml(s.name) +
      '</strong>' +
      this.buildStoreDetailsHtml(s, true) +
      '</div>';

    this.infoWindow.setContent(html);
    this.infoWindow.open({ anchor: marker, map: this.map });
    this.map.panTo(marker.getPosition());

    var items = this.resultsEl.querySelectorAll('[data-store-index]');
    items.forEach(function (el) {
      el.classList.toggle('is-active', Number(el.dataset.storeIndex) === idx);
    });
  };

  StoreLocator.prototype.renderList = function (stores) {
    var self = this;
    if (!stores.length) {
      this.resultsEl.innerHTML = '<p style="margin:0">No hay tiendas para la selección actual.</p>';
      return;
    }

    var html = '<ul>';
    stores.forEach(function (s, idx) {
      html +=
        '<li data-store-index="' +
        idx +
        '">' +
        '<strong class="store-locator__store-name">' +
        escapeHtml(s.name) +
        '</strong>' +
        self.buildStoreDetailsHtml(s, false) +
        '</li>';
    });
    html += '</ul>';
    this.resultsEl.innerHTML = html;

    this.resultsEl.querySelectorAll('[data-store-index]').forEach(function (el) {
      el.addEventListener('click', function () {
        var idx = Number(el.dataset.storeIndex);
        var marker = self.markers[idx];
        if (!marker) return;
        self.activateStore(idx, stores, marker);
      });
    });
  };

  function boot() {
    document.querySelectorAll('.js-store-locator').forEach(function (root) {
      try {
        var locator = new StoreLocator(root);
        locator.init();
      } catch (e) {
        var results = root.querySelector('.store-locator__results');
        if (results) results.textContent = 'No fue posible inicializar el localizador.';
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
